import { useRouter } from 'next/router';
import React from 'react';
import { SVGBabyNames } from '../../../../Svg/BabyNamesPage';
import { convertToQuery } from '../../../../Utils/helper';
import { SearchInput } from './styled';

export default function Search(props) {
  const { searchText, field, detailPage } = props;
  const router = useRouter();
  const { query } = useRouter();
  const getRoutePath = () => {
    if (detailPage) {
      return `search?`;
    }
    return `babynames/search?`;
  };
  const redirect = (e) => {
    e.preventDefault();
    let obj = { ...query };
    obj.page = 1;
    obj[field] = searchText.current;
    if (field == 'name') {
      delete obj[field];
      obj['search'] = searchText.current;
    }
    let qs = convertToQuery(obj);
    router.push(`${getRoutePath()}` + qs);
  };
  return (
    <SearchInput>
      <SVGBabyNames id="searchblacknew" />
      {/* <img src="/images/searchblacknew.svg" alt="" /> */}
      <form onSubmit={redirect}>
        <input
          type="text"
          name=""
          id=""
          placeholder={`Type a ${field} here...`}
          onChange={(e) => {
            searchText.current = e.target.value;
          }}
        />
      </form>
    </SearchInput>
  );
}
